<template>
  <teleport to="#app">
    <transition name="toast-slide" mode="out-in" appear @after-leave="handleAfterLeave">
      <div v-if="show" class="modern-toast-wrap" @click="show = false" :style="{ zIndex }">
        <div class="toast-content" :class="`toast-${type}`">
          <div class="toast-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path :d="iconPath"/>
            </svg>
          </div>
          <p class="toast-message">{{ message }}</p>
        </div>
      </div>
    </transition>
  </teleport>
</template>
<script src="./instance.js"></script>
<style lang="less" scoped>
.modern-toast-wrap {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  pointer-events: auto;

  .toast-content {
    display: flex;
    align-items: center;
    gap: 12px;
    backdrop-filter: blur(10px);
    padding: 16px 24px;
    border-radius: 12px;
    min-width: 300px;
    max-width: 500px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(255, 255, 255, 0.2);

    &:hover {
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }

    // 信息类型（默认 - 紫色渐变）
    &.toast-info {
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.95) 0%, rgba(118, 75, 162, 0.95) 100%);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2),
                  0 2px 8px rgba(102, 126, 234, 0.3);

      &:hover {
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25),
                    0 4px 12px rgba(102, 126, 234, 0.4);
      }
    }

    // 成功类型（绿色渐变）
    &.toast-success {
      background: linear-gradient(135deg, rgba(103, 194, 58, 0.95) 0%, rgba(133, 206, 97, 0.95) 100%);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2),
                  0 2px 8px rgba(103, 194, 58, 0.3);

      &:hover {
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25),
                    0 4px 12px rgba(103, 194, 58, 0.4);
      }
    }

    // 警告类型（橙色渐变）
    &.toast-warning {
      background: linear-gradient(135deg, rgba(230, 162, 60, 0.95) 0%, rgba(245, 186, 96, 0.95) 100%);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2),
                  0 2px 8px rgba(230, 162, 60, 0.3);

      &:hover {
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25),
                    0 4px 12px rgba(230, 162, 60, 0.4);
      }
    }

    // 错误类型（红色渐变）
    &.toast-error {
      background: linear-gradient(135deg, rgba(245, 108, 108, 0.95) 0%, rgba(247, 137, 137, 0.95) 100%);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2),
                  0 2px 8px rgba(245, 108, 108, 0.3);

      &:hover {
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25),
                    0 4px 12px rgba(245, 108, 108, 0.4);
      }
    }

    .toast-icon {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: pulse 2s ease-in-out infinite;

      svg {
        width: 100%;
        height: 100%;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
      }
    }

    .toast-message {
      flex: 1;
      margin: 0;
      color: white;
      font-size: 15px;
      font-weight: 500;
      line-height: 1.5;
      text-align: left;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
  }
}

// 动画效果
.toast-slide-enter-active {
  animation: toastSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-slide-leave-active {
  animation: toastSlideOut 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes toastSlideIn {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
}

@keyframes toastSlideOut {
  0% {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px) scale(0.9);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .modern-toast-wrap {
    top: 60px;
    left: 16px;
    right: 16px;
    transform: none;

    .toast-content {
      min-width: auto;
      max-width: none;
      padding: 14px 20px;

      .toast-message {
        font-size: 14px;
      }
    }
  }

  @keyframes toastSlideIn {
    0% {
      opacity: 0;
      transform: translateY(-20px) scale(0.9);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes toastSlideOut {
    0% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
    100% {
      opacity: 0;
      transform: translateY(-20px) scale(0.9);
    }
  }
}
</style>
